import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../../lib/rtkBaseQuery";



export const emptySplitApi = createApi({
    baseQuery:baseQueryWithReauth,
    tagTypes:['Institution','InstitutionCategory','Screens','LoanInfo','LoanPaymentInfos','Screening','User','Custom','Dashboard','Frame','ScreenFrameConfig','File','ComponentContent','Alert','PlaybackHistory'],
    endpoints:() => ({}),
})